export default {
  bind (el, binding, vnode) {
    let dialogHeader = el.querySelector('.draggable-header')
    if (!dialogHeader) {
      dialogHeader = el
    }

    let isDragging = false
    let startX = 0
    let startY = 0
    let originalLeft = 0
    let originalTop = 0

    dialogHeader.style.cursor = 'move'
    dialogHeader.style.userSelect = 'none'

    const onMouseDown = (e) => {
      // 只允许左键拖拽
      if (e.button !== 0) return

      isDragging = true
      startX = e.clientX
      startY = e.clientY

      // 获取当前元素位置
      const rect = el.getBoundingClientRect()
      originalLeft = rect.left
      originalTop = rect.top

      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseup', onMouseUp)

      e.preventDefault()
    }

    const onMouseMove = (e) => {
      if (!isDragging) return

      const deltaX = e.clientX - startX
      const deltaY = e.clientY - startY

      let newLeft = originalLeft + deltaX
      let newTop = originalTop + deltaY

      // 边界限制（可选）
      const maxX = window.innerWidth - el.offsetWidth
      const maxY = window.innerHeight - el.offsetHeight
      newLeft = Math.min(Math.max(newLeft, 0), maxX)
      newTop = Math.min(Math.max(newTop, 0), maxY)

      el.style.position = 'fixed'
      el.style.left = newLeft + 'px'
      el.style.top = newTop + 'px'
      el.style.right = 'auto'
      el.style.bottom = 'auto'

      // 触发自定义事件
      vnode.componentInstance?.$emit('dragging', { left: newLeft, top: newTop })
    }

    const onMouseUp = () => {
      isDragging = false
      document.removeEventListener('mousemove', onMouseMove)
      document.removeEventListener('mouseup', onMouseUp)

      vnode.componentInstance?.$emit('drag-end', {
        left: parseFloat(el.style.left),
        top: parseFloat(el.style.top)
      })
    }

    dialogHeader.addEventListener('mousedown', onMouseDown)

    // 保存清理函数
    el.__draggableCleanup__ = () => {
      dialogHeader.removeEventListener('mousedown', onMouseDown)
      document.removeEventListener('mousemove', onMouseMove)
      document.removeEventListener('mouseup', onMouseUp)
    }
  },

  unbind (el) {
    if (el.__draggableCleanup__) {
      el.__draggableCleanup__()
    }
  }
}
